import { FunctionComponent, ReactNode } from 'react'

import emptyStateCss from './emptyState.module.scss'

const EmptyState: FunctionComponent<{
  icon?: ReactNode
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
}> = ({ icon, title, description, action }) => (
  <div className={emptyStateCss.emptyState}>
    {icon && <span className={emptyStateCss.icon}>{icon}</span>}
    <h2 className={emptyStateCss.title}>{title}</h2>
    {description && <p className={emptyStateCss.description}>{description}</p>}
    {action && <div className={emptyStateCss.action}>{action}</div>}
  </div>
)

export default EmptyState
